import { AfterViewChecked, ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { CustomerLocationModalComponent } from '@ml/shared/components/customer-location-modal/customer-location-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { GoogleMapsService } from '@ml/shared/services/google-maps.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MediaObserver } from '@angular/flex-layout';
var SelectLocationsTableComponent = /** @class */ (function () {
    function SelectLocationsTableComponent(dialog, googleMapsService, cdRef, mediaObserver) {
        this.dialog = dialog;
        this.googleMapsService = googleMapsService;
        this.cdRef = cdRef;
        this.mediaObserver = mediaObserver;
        this.addLocations = new EventEmitter();
        this.removeLocations = new EventEmitter();
        this.updatePositions = new EventEmitter();
        this.displayedColumns = [
            'index',
            'name',
            'status',
            'preview',
            'navigation',
            'select'
        ];
    }
    SelectLocationsTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selection = new SelectionModel(true, this.selectedLocations);
        this.selection.changed
            .asObservable()
            .pipe(distinctUntilChanged())
            .subscribe(function (value) {
            if (value.added.length > 0) {
                _this.addLocations.emit(value.added);
            }
            if (value.removed.length > 0) {
                _this.removeLocations.emit(value.removed);
            }
        });
    };
    SelectLocationsTableComponent.prototype.ngAfterViewChecked = function () {
        this.cdRef.detectChanges();
    };
    /** Whether the number of selected elements matches the total number of rows. */
    SelectLocationsTableComponent.prototype.isAllSelected = function () {
        var numSelected = this.selection.selected.length;
        var numRows = this.locations.length;
        return numSelected === numRows;
    };
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    SelectLocationsTableComponent.prototype.masterToggle = function () {
        var _a;
        if (this.isAllSelected()) {
            return this.selection.clear();
        }
        var ids = this.locations.map(function (value) { return value.id; });
        (_a = this.selection).select.apply(_a, ids);
    };
    SelectLocationsTableComponent.prototype.onPreview = function (location) {
        var isTablet = this.mediaObserver.isActive('lg');
        this.dialog.open(CustomerLocationModalComponent, {
            width: isTablet ? '800px' : '100vw',
            maxWidth: '100vw',
            data: {
                location: location,
                disable: true
            }
        });
    };
    SelectLocationsTableComponent.prototype.onNavigation = function (location) {
        this.googleMapsService.navigateTo(location);
    };
    SelectLocationsTableComponent.prototype.dropTable = function (event) {
        var prevIndex = this.locations.findIndex(function (d) { return d.id === event.item.data.id; });
        var locations = this.locations.slice();
        moveItemInArray(locations, prevIndex, event.currentIndex);
        this.locations = locations.slice();
        var updatePositions = this.locations.map(function (location, index) { return ({
            id: location.id,
            position: index
        }); });
        this.updatePositions.emit(updatePositions);
    };
    return SelectLocationsTableComponent;
}());
export { SelectLocationsTableComponent };
